<template>
  <div class="category">
    <h3>
      <img :alt="listName" class="avatar" :src="avatarPath">
      {{ listName }}
    </h3>
    <ul v-if="list.length">
      <WishListItem v-for="(item) of list" :key="item.id" :item="item" @selectedItem="(item) => selectItem(item)" />
    </ul>
    <p v-else class="empty">Ще формулюю бажання :)</p>
  </div>
</template>


<script>
import WishListItem from './WishListItem.vue'

export default {
  name: 'WishListCategory',
  emits: ['selectedItem'],
  components: {
    WishListItem
  },
  props: {
    list: Array,
    listKey: String,
    listName: String
  },
  data() {
    return {
      avatarPath: `/images/${this.listKey}.jpg`
    }
  },
  methods: {
    selectItem(item) {
      console.log('selectItem', item)
      this.$emit('selectedItem', item);
    }
  }
}
</script>

<style scoped>
h3 {
  margin: 0 8px;
  font-size: 2em;
  color: #69A1B5;
}

.category {
  margin-bottom: 40px;
}

ul {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.empty {
  padding: 8px;
}

.avatar {
  position: relative;
  display: inline-block;
  bottom: -15px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 3px solid currentColor;
}
</style>
